// extracted by mini-css-extract-plugin
module.exports = {"slider":"VoiceAudioSettings_slider__scVdr","select":"VoiceAudioSettings_select__Li0zG"};